// Domain gating — COLLAPSED (2026-06)
// team.avidahealth.org has been merged into app.avidahealth.org. There is now
// ONE unified app. "Team Comms" is gated by ROLE (not by domain). Anyone who
// lands on a team.* host is redirected to the matching app.* URL by
// redirectTeamToApp() (called at app entry in index.js). In dev/preview the
// hostname is neither team.* nor app.*, so nothing redirects and full access
// applies. The isTeamDomain/isAppDomain helpers are kept (returning constants)
// so existing imports keep working while the team-only branches go inert.

export function redirectTeamToApp() {
  try {
    const { hostname, pathname, search, hash, protocol } = window.location;
    if (hostname.startsWith("team.")) {
      const target = `${protocol}//${hostname.replace(/^team\./, "app.")}${pathname}${search}${hash}`;
      window.location.replace(target);
      return true;
    }
  } catch {
    /* SSR / private mode noop */
  }
  return false;
}

export function getDomainMode() {
  return "app"; // collapsed — single unified app
}

export function isTeamDomain() {
  return false;
}

export function isAppDomain() {
  return true;
}

// Comms visibility is role-based: everyone except PCWs can access Team Comms.
export function canAccessComms(userRole) {
  return userRole !== "pcw";
}
